import {
    GET_ES_USER_ROLES_STARTED,
    GET_ES_USER_ROLES_SUCCESS,
    GET_ES_USER_ROLES_FAILURE
  } from '../constants/auth.constant';
  
  const initialState = {
    loading: false,
    getESUserRolesInfo: [],
    error: null
  };
  
  export default function getESUserRolesReducer(state = initialState, action) {
    switch (action.type) {
      case GET_ES_USER_ROLES_STARTED:
        return {
          ...state,
          loading: true
        };
      case GET_ES_USER_ROLES_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          getESUserRolesInfo: action.payload
        };
      case GET_ES_USER_ROLES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload.error
        };
      default:
        return state;
    }
  }